import React, { useEffect, useRef, useState } from 'react'

import './styles.scss'
import { Counter } from 'components/Counter'
import 'mapbox-gl/dist/mapbox-gl.css'
import mapboxgl from 'mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax

const countrydata = require('components/main/babiespercountry')
mapboxgl.accessToken =
  'pk.eyJ1IjoidGEtaW50ZXJha3RpdiIsImEiOiJjaXNhNGFsdHAwMDB2Mm9wNWdlMTlqMTNuIn0.uj5aGvF3yvEM4V6kNdlbVg'

const isMobile = window.innerWidth < 711
const scrollTo = (id: string) => {
  let el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  }
}
export const Map = ({ step, blink }: { step: number; blink?: boolean }) => {
  const mapContainer = useRef(null)
  const map = useRef<mapboxgl.Map>(null)
  const [lng, setLng] = useState(-4)
  const [lat, setLat] = useState(46)
  const [zoom, setZoom] = useState(isMobile ? 0.6 : 1.3)
  const [markerPositions, setMarkerPositions] = useState<
    {
      id: string
      step: number
      pos: { x: number; y: number }
      label: React.ReactChild
      labelPos?: 'above' | 'below' | 'left' | 'right'
    }[]
  >()
  let timers: any[] = []

  useEffect(() => {
    if (!map.current || !blink) return
    countrydata.forEach(element => {
      timers.push(
        setInterval(() => {
          map.current.setFilter('highlight', [
            'match',
            ['get', 'iso_3166_1_alpha_3'],
            [element.iso3],
            true,
            false
          ])
        }, element.interval * 1000)
      )
    })

    return () => {
      timers.forEach(timer => {
        clearInterval(timer)
      })
    }
  }, [map.current])

  useEffect(() => {
    if (map.current) return // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/ta-interaktiv/ckzo9hcas00jy14l8kr1g9g68/draft',
      center: [lng, lat],
      zoom: zoom,
      interactive: false,
      renderWorldCopies: false
    })

    map.current.on('move', e => {
      setMarkerPositions([
        {
          id: 'algen',
          step: 4,
          pos: map.current.project([8.533864470195038, 47.37521811647257]),
          label: (
            <>
              <img src={require('./icon_algen.png')} />
              <div className='bg'>
                <b>Mikroalgen</b>,<br />
                Zürich
              </div>
            </>
          ),
          labelPos: 'above'
        },
        {
          id: 'invitro',
          step: 3,
          pos: map.current.project([8.664817410959564, 47.23013225588482]),
          label: (
            <>
              <img src={require('./icon_invitro.png')} />
              <div className='bg'>
                <b>In-vitro-Fleisch</b>,<br />
                Wädenswil
              </div>
            </>
          ),
          labelPos: 'below'
        },
        {
          id: 'insects',
          step: 2,
          pos: map.current.project([8.060931120661131, 47.39152712689637]),
          label: (
            <>
              <img src={require('./icon_insects.png')} />
              <div className='bg'>
                <b>Insekten</b>,<br />
                Aargau
              </div>
            </>
          ),
          labelPos: 'below'
        }
      ])
    })
  }, [])
  useEffect(() => {
    if (blink) {
      map.current.flyTo({
        center: [lng, lat],
        zoom: zoom
      })
    }
    if (!blink) {
      if (step === 0) {
        map.current.flyTo({
          center: [lng, lat],
          zoom: zoom
        })
      }
      if (step === 1) {
        map.current.flyTo({ center: [8.3, 46.8], zoom: isMobile ? 6 : 7.3 })
        timers.forEach(timer => {
          clearInterval(timer)
        })
      }
      if (step > 1)
        map.current.flyTo({
          center: [8.37, 47.23],
          zoom: isMobile ? 7.9 : 9
        })
    }
  }, [step])
  return (
    <div
      className='map-wrapper'
      style={{ height: '100vh', pointerEvents: 'none' }}
    >
      <div ref={mapContainer} className='map-container' />
      <div className='mapoverlay'>
        {blink && <Counter />}
        {markerPositions &&
          !blink &&
          step >= 1 &&
          markerPositions.map((m, i) => {
            return (
              <>
                {step >= m.step && (
                  <div
                    className={'marker ' + m.labelPos}
                    style={{ top: m.pos.y + 'px', left: m.pos.x + 'px' }}
                    onClick={() => scrollTo(m.id)}
                  >
                    {m.label}
                  </div>
                )}
              </>
            )
          })}
      </div>
    </div>
  )
}
